// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"8db032cf","83":"5463e500","348":"e12c3a12","478":"094b27f0","482":"a569ed16","488":"dcf484c7","574":"35d4909f","951":"b76b13fa"}[chunkId] + ".chunk.js";
};